(function () {
  if (window.__sacrasoulDeliveryEstimate) return;
  window.__sacrasoulDeliveryEstimate = true;

  var WAREHOUSE_TZ = 'Europe/Warsaw';

  /* NO COUNTRY TABLE LIVES HERE (2026-09-17).
     The transit window arrives on the markup as data-transit-min/max, rendered
     by snippets/delivery-estimate.liquid from snippets/shipping-rate-value.liquid
     — the single source of truth that mirrors the live Shopify delivery profile.

     Until today this file carried its own per-country table and the cart drawer
     carried a third one. Every one of the 31 countries we ship to was quoted a
     different window by the three of them: GB 4-7 here against 3-5 at checkout,
     DE/CZ/SK a flat 3 against 2-4, CH 4-5 against 5-7, BG/GR 4-5 against 5-8,
     and CY/MT missing entirely so they fell to a 7-14 default against a real
     5-8. The table also quoted Oman, Australia and Brazil, which Shopify
     refuses at checkout with "Country/region not supported".

     The window is in WORKING days, which is why addWorkingDays below skips
     Saturday and Sunday. Adding them as calendar days would quietly shorten
     every promise the rate table makes. */

  function addWorkingDays(date, days) {
    /* Local Date methods. The caller works in Warsaw-local time
       (see compute()), so local matches Warsaw and the weekend skip
       lands on the right day. */
    var result = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      var day = result.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return result;
  }

  function formatDate(d, locale) {
    /* Locale-aware short date. The date we pass in already represents
       Warsaw-local moments via the toLocaleString trick, so we format
       in the browser local zone (the parsed timestamp's frame). */
    try {
      var fmt = new Intl.DateTimeFormat(locale || 'en-GB', {
        weekday: 'short', day: 'numeric', month: 'short'
      });
      return fmt.format(d);
    } catch (e) {
      var WEEKDAY = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
      var MONTH = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      return WEEKDAY[d.getDay()] + ' ' + d.getDate() + ' ' + MONTH[d.getMonth()];
    }
  }

  function readWindow(root) {
    /* Blank means the shopper's country is outside the delivery profile.
       Shopify answers "Country/region not supported" for it at checkout, so
       there is no honest date to print and we print none. The snippet already
       declines to render the row in that case; this is the second lock, for a
       cached or hand-edited fragment that reaches us anyway. */
    var min = parseInt(root.getAttribute('data-transit-min'), 10);
    var max = parseInt(root.getAttribute('data-transit-max'), 10);
    if (!isFinite(min) || !isFinite(max) || min < 0 || max < min) return null;
    return [min, max];
  }

  function compute(root) {
    /* A pre-order instance renders its ship date server-side; the transit estimator
       must not overwrite it with "arrives Tuesday, ships in 24h". */
    if (root.getAttribute('data-preorder') === '1') return;

    var range = readWindow(root);
    if (!range) { root.setAttribute('hidden', ''); return; }

    var locale = root.getAttribute('data-locale') || 'en';
    var tArrives = root.getAttribute('data-t-arrives') || 'Arrives';
    var tSep = root.getAttribute('data-t-sep') || 'to';
    var tShipsNext = root.getAttribute('data-t-ships-next') || 'Ships next working day';

    /* Weekday checks happen in the warehouse timezone (Warsaw) so the PDP
       agrees with the cart drawer. DST-safe. */
    var nowWarsaw = new Date(new Date().toLocaleString('en-US', { timeZone: WAREHOUSE_TZ }));

    /* DISPATCH IS THE NEXT WORKING DAY, ALWAYS (2026-09-17).
       There is no same-day cut-off. This file used to ship today when the
       Warsaw clock read before 15:00, which is one working day earlier than
       the warehouse has ever managed and one working day earlier than the
       shipping page has promised since #1992. Friday dispatches Monday,
       Saturday and Sunday dispatch Monday, Monday dispatches Tuesday —
       which is exactly one working day forward. */
    var shipDate = addWorkingDays(nowWarsaw, 1);

    var earliest = addWorkingDays(shipDate, range[0]);
    var latest = addWorkingDays(shipDate, range[1]);

    var lineEl = root.querySelector('[data-delivery-line]');
    var subEl = root.querySelector('[data-delivery-sub]');
    if (lineEl) {
      var line;
      if (earliest.getDate() === latest.getDate() && earliest.getMonth() === latest.getMonth()) {
        line = tArrives + ' ' + formatDate(earliest, locale);
      } else {
        line = tArrives + ' ' + formatDate(earliest, locale) + ' ' + tSep + ' ' + formatDate(latest, locale);
      }
      /* The returns clause that follows this element opens with a bare space, in
         every language. So this line has to end in a terminal stop, and the date
         only sometimes does: Intl gives German a stop in 8 months of 12 and none
         in March, May, June or July, where the month name is not abbreviated.
         Czech is numeric and always ends in one; Polish and English never do.
         Asking the question of the STRING rather than of the language is the only
         version that survives a CLDR change. */
      lineEl.textContent = /[.!?]$/.test(line) ? line : line + '.';
    }
    if (subEl) {
      subEl.textContent = tShipsNext;
    }
  }

  function refreshAll() {
    var roots = document.querySelectorAll('[data-delivery-estimate]');
    for (var i = 0; i < roots.length; i++) compute(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }

  // Recompute when the cart drawer opens (new instances may have appeared)
  document.addEventListener('cart:updated', refreshAll);
  document.addEventListener('cart-drawer:opened', refreshAll);
  /* A country change is a Shopify localization form submit, so the window is
     re-rendered by the server with the page. There is nothing left for a
     client-side country listener to recompute — the table it used to pick a
     row from is gone. */
})();
